import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Avatar from 'react-avatar';

import patrick from "../photos/Mrun copy.jpg";
import Justus from "../photos/Justus copy.jpg";
import dame from "../photos/sura.jpg";
import sur from "../photos/photo.png";
import wicked from "../photos/Wicked.jpeg";
import HK from "../photos/HKlogo.png";

const testimonialsData = [
  {
    quote: "Campus Closet is a breakthrough – selling my items has never been this easy and profitable!",
    author: "Patrick Murani",
    role: "CEO of StarfiniteX.",
    photo: patrick,
  },
  {
    quote: "Finally, a solution that breaks through the inconvenience of traditional marketing. Campus Closet is a game-changer!",
    author: "Gitau Justus",
    role: "CEO of J'ASTUTE.",
    photo: Justus,
  },
  {
    quote: "Selling and buying on Campus Closet is a breeze. Say goodbye to hassle, hello to convenience!",
    author: "Anthony Mariga",
    role: "CEO of JUSANTO",
    photo: sur,
  },
  {
    quote: "No more marketing woes! Thanks to Campus Closet, my items find buyers easily, hassle-free.",
    author: "Wicklife Munene",
    role: "CEO of WICKED ALBUM",
    photo: wicked,
  },
  {
    quote: "Buying smart, selling smart – Campus Closet's simplicity is a win for students. Join the future of campus commerce!",
    author: "Jackline Chepkoech",
    role: "Accountant",
    photo: dame,
  },
  {
    quote: "Registration and login process is swift and direct.",
    author: "Harrison Kebeya",
    role: "Campus Closet User",
    photo: HK,
  },
];

const Testimonials = () => {
  return (
    <div className="bg-slate-50 py-10">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl text-center font-extrabold text-gray-900">
          What Our Users Say
        </h2>
        <OwlCarousel
          className="owl-theme mt-6"
          items={1}
          loop={true}
          autoplay={true}
          autoplayTimeout={5000}
          autoplayHoverPause={true}
          nav
          dots
          margin={8}
          navText={[
            '<span class="custom-prev-button text-lg font-bold"><</span>',
            '<span class="custom-next-button text-lg font-bold">></span>'
          ]}
        >
          {testimonialsData.map((testimonial, index) => (
            <div
              key={index}
              className="max-w-lg mx-auto bg-white shadow-lg rounded-lg mb-5 py-2 px-4 items-center"
            >
              <div>
                <p className="md:text-lg text-gray-700 font-open-sans">
                  "{testimonial.quote}"
                </p>
              </div>
              <div className="flex mt-2">
                <span className="w-16 h-16 mr-4 rounded-full overflow-hidden items-center">
                  <img src={testimonial.photo} alt={testimonial.author} />
                </span>
                <span>
                  <h2 className="text-xl text-gray-900 font-bold">
                    {testimonial.author}
                  </h2>
                  <p className="text-sm text-gray-500">{testimonial.role}</p>
                </span>
              </div>
            </div>
          ))}
        </OwlCarousel>
      </div>
    </div>
  );
};

export default Testimonials;
